import Api from "../axios";

export const getViewNotice = async (id) => {
  return await Api.get(`/view_notice?policy_id=${id}`);
};